// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SiteSharedContactModel {
    static getAttributeTypeMap() {
        return SiteSharedContactModel.attributeTypeMap;
    }
}
SiteSharedContactModel.discriminator = undefined;
SiteSharedContactModel.attributeTypeMap = [
    {
        "name": "contactId",
        "baseName": "contactId",
        "type": "number"
    },
    {
        "name": "isActive",
        "baseName": "isActive",
        "type": "boolean"
    },
    {
        "name": "addresses",
        "baseName": "addresses",
        "type": "Array<SiteSharedAddressModel>"
    },
    {
        "name": "phoneNumbers",
        "baseName": "phoneNumbers",
        "type": "Array<SiteSharedPhoneModel>"
    },
    {
        "name": "emailAddresses",
        "baseName": "emailAddresses",
        "type": "Array<SiteSharedEmailAddressModel>"
    },
    {
        "name": "webAddresses",
        "baseName": "webAddresses",
        "type": "Array<SiteSharedWebAddressModel>"
    },
    {
        "name": "contactType",
        "baseName": "contactType",
        "type": "RoleType"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "occupationDescription",
        "baseName": "occupationDescription",
        "type": "string"
    },
    {
        "name": "isMainContact",
        "baseName": "isMainContact",
        "type": "boolean"
    }
];
//# sourceMappingURL=siteSharedContactModel.js.map